class SedeDetalle extends React.Component {
  constructor() {
    super();
    this.state = {
      mapOptions: {
        center: {
          lat: 4.6489681,
          lng: -74.1325349
        },
        zoom: 12
      }
    };
    this.googleChecker = this.googleChecker.bind(this);
  }

  componentDidMount() {
    //this.googleChecker();
  }

  googleChecker() {
    // if(!window.google || !window.google.maps) {
    //   setTimeout(this.googleChecker, 200);
    // } else {
    this.renderMap();
    // }
  }

  renderInfoWindow(location) {
    const image = location.image;
    let srcWithQuotes = image.match(/src\=([^\s]*)\s/)[1];
    srcWithQuotes.substring(1, srcWithQuotes.length - 1);
    const locImage =
      '<img alt="" class="venue-image" src=' +
      srcWithQuotes +
      ' oncontextmenu="return false;" style="BORDER: 0px solid; ">';
    return (
      '<div class="info">' +
      locImage +
      '<div class="infosede">' +
      "<h3>" +
      location.name +
      "</h3>" +
      (location.phone ? '<p class="telefono">' + location.phone + "</p>" : "") +
      (location.address
        ? '<p class="pinUbicacion">' + location.address + "</p>"
        : "") +
      // (location.schedule ? ('<p><i class="fa fa-clock-o" aria-hidden="true"></i> ' + location.schedule + '</p>') : '') +
      // (location.parking ? ('<p><i class="fa fa-car" aria-hidden="true"></i> ' + location.parking + '</p>') : '') +
      '<select id="how-to-arrive-select"><option value="">Cómo Llegar</option><option value="DRIVING">Vehículo particular</option><option value="TRANSIT">Transporte público</option><option value="WALKING">Caminando</option></select>' +
      (location.url
        ? '<a class="btn btn-primary" href="https://corporativo.compensar.com/sedes/' +
          location.url +
          '" target="_blank" >Más información</a>'
        : "") +
      '<a class="cerrarCaja"></a>' +
      "</div>" +
      "</div>"
    );
  }

  activeMap = e => {
    e.preventDefault();
    if (window.google && window.google.maps) {
      this.renderMap();
    }
  };

  renderMap() {
    const latLng = {
      lat: this.props.location.lat,
      lng: this.props.location.lng
    };
    const mapOptions = {
      center: latLng,
      zoom: 12
    };

    this.map = new google.maps.Map(this.refs.mapContainer, mapOptions);

    const infowindow = new google.maps.InfoWindow({
      maxWidth: 280,
      content: this.renderInfoWindow(this.props.location)
    });
    const marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      animation: google.maps.Animation.DROP,
      title: this.props.location.name,
      location: this.props.location
    });
    const directionsDisplay = new google.maps.DirectionsRenderer();

    /*let allowGeolocation = false;
    let currentLatLng = {};
    if (location.protocol == 'https:') {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state == 'granted') {
          allowGeolocation = true;
          navigator.geolocation.getCurrentPosition((position) => {
            currentLatLng = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
          });
        }
      });
    }*/

    marker.addListener("click", () => {
      infowindow.open(this.map, marker);
      this.map.panTo(marker.getPosition());
      const closeMarker = document.querySelector(".cerrarCaja");
      closeMarker.addEventListener("click", e => {
        infowindow.close();
      });
      const howToArriveSelect = document.getElementById("how-to-arrive-select");
      howToArriveSelect.addEventListener("change", e => {
        if (howToArriveSelect.value) {
          console.log("image ", document.getElementsByClassName("info"));
          navigator.geolocation.getCurrentPosition(
            position => {
              let currentLatLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              infowindow.close();
              const directionsService = new google.maps.DirectionsService();
              directionsDisplay.setMap(this.map);
              directionsService.route(
                {
                  origin: { lat: currentLatLng.lat, lng: currentLatLng.lng },
                  destination: {
                    lat: this.props.location.lat,
                    lng: this.props.location.lng
                  },
                  travelMode: google.maps.TravelMode[e.target.value]
                },
                (response, status) => {
                  if (status == "OK") {
                    directionsDisplay.setDirections(response);
                    directionsDisplay.setOptions({
                      polylineOptions: {
                        strokeWeight: 4,
                        strokeOpacity: 1,
                        strokeColor: "red"
                      }
                    });
                  } else {
                    console.log("Directions request failed due to " + status);
                  }
                }
              );
            },
            error => {
              console.log("The user did not allowed geolocation");
            }
          );
        }
      });
    });
  }

  render() {
    return (
      <div className='row'>
        <div className='col-sm-3'>
          <h3>Zona: {this.props.location.zone}</h3>
          {/*  {this.props.location.description} */}
          <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
          <strong>{this.props.location.name}</strong>
          <br />
          <i className='fa fa-map-marker'></i> {this.props.location.address}
          <br />
          <i className='fa fa-phone'></i> Teléfono {this.props.location.phone}
          <br />
        </div>
        <div className='col-sm-9'>
          <div id='map' ref='mapContainer' style={{ height: "400px" }}>
            <img
              src={`${_spPageContextInfo.siteAbsoluteUrl}/PublishingImages/sedes/mapa-sedes-prev1.jpg`}
              alt='Sedes de compensar'
              onClick={this.activeMap}
              style={{
                height: "100%",
                width: "100%",
                "object-fit": "cover",
                cursor: "pointer"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SedeDetalle;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/otrosServiciosRedDeUrgencias/src/components/sedeDetalle.js